module.exports = __webpack_public_path__ + "img/pm25_en.ea9f807f.jpg";